import moment from 'moment';

export const ISO_8601_FORMAT = 'YYYY-MM-DD';

// Moment will default to current date if you don't pass date
export const dateToISO8601 = (date?: Date) => moment(date).format(ISO_8601_FORMAT);

export const iso8601ToDate = (date: string) => moment(date, ISO_8601_FORMAT).toDate();
